import { FC, ReactElement } from 'react'
import { Link } from 'react-router-dom'

import { getVendors } from '../../constants'
import { useI18n } from '../../hooks'
import Image from '../atoms/images/image'

import './vendors.css'

const VendorList: FC = (): ReactElement => {
  const { t } = useI18n()

  return (
    <div className="vendor-list">
      {getVendors().map((vendor, i) => (
        <Link
          id={`vendor-anchor-${i}`}
          className="vendor-anchor"
          key={vendor.name + i}
          to={vendor.url}
          target="_blank"
          rel="noreferrer"
          aria-label={vendor.name + t('Vendor_page')}
        >
          <Image className="vendor-icon" src={vendor.icon} size={{ width: 130, height: 30 }} alt={vendor.name + t('Vendor_icon')} />
        </Link>
      ))}
    </div>
  )
}

export default VendorList
